import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { durationEditor } from '../../../assets/js/field_config/editor-inline-gantt';

const durationCol = (gantt, t) => {
  const name = 'duration';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    label: t('gantt.columns.duration', 'Duración'), // Assuming translation
    align: 'center',
    width: '80',
    resize: true,
    editor: gantt ? durationEditor(gantt) : null,
    template: (activity) => {
      const hasChild = gantt.hasChild(activity.id);
      const isOdd = gantt.oddColsConfig?.duration || false;
      const lang = t('lang');

      // Precompute duration_string based on activity properties
      let rawDuration = activity.for_disable_milestone_duration !== 0
        ? gantt.formatter.format(activity.for_disable_milestone_duration)
        : '0 days';
      
      // The original template had complex nested div string construction.
      // Simplifying by preparing the final display string.
      let displayDuration = lang === 'en' ? rawDuration : rawDuration.replace('.', ',');

      return `
        <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="${hasChild ? 'font-weight: 600' : 'font-weight: 100'}">
          ${displayDuration}
        </div>
      `;
    },
    hide: !isVisible,
    data_type: 'number',
    groupable: false,
    orderable: false, // Original was false
    orderable_switch: ['1 → 9', '9 → 1'],
    filterable: true,
  };
};

export default durationCol; 